import { PayloadAction } from '@reduxjs/toolkit';
import { ImageHandlingState } from '@reducers/v2/imageHandlingV2/imageHandlingV2.slice';

export const setSelectedNoteIdAction = (state: ImageHandlingState, action: PayloadAction<number | null>) => {
  state.selectedNoteId = action.payload;
};
